// extracted by mini-css-extract-plugin
module.exports = {"GlobalSearch":"_1-Qi8xeCJ_85IkwXwMUjuQ","search-container":"_3PVtDkIcT1gnlDUxkZU75F"};